/* WASA Coffee, round 35 (lane W4): the glass header steps aside while you read, and comes back the moment you
   scroll up.

   - Until the reader has scrolled past the homepage's Featured Origin section (one screen height on pages without
     it), the header always stays.
   - After that, scrolling down slides it away and scrolling up slides it back.
   - It never hides while the mobile menu, a dropdown, search or the bag is open, or while keyboard focus is inside it.
   - It keeps --wasa-r35-hdr-bottom (the header's bottom edge on screen) current, so the dropdown and search panels
     open right under it once the announcement bar has scrolled away.
   The slide itself lives in wasa-r35.css (transform only; a plain show and hide under reduced motion).
   To undo: remove this file's line from layout/theme.liquid. */
(function () {
  'use strict';

  var group = document.querySelector('.header-group');
  if (!group) return;

  var root = document.documentElement;
  var HIDDEN = 'wasa-hdr-hidden';
  var lastY = window.pageYOffset || 0;
  var hidden = false;
  var queued = false;
  var threshold = 0;

  function measureThreshold() {
    var origin = document.querySelector('.wasa-feat-section, .wasa-feat');
    if (origin) {
      var r = origin.getBoundingClientRect();
      threshold = r.bottom + (window.pageYOffset || 0);
    } else {
      threshold = window.innerHeight;
    }
  }

  function somethingOpen() {
    if (group.contains(document.activeElement) && document.activeElement !== document.body) return true;
    return !!document.querySelector(
      '#mobNavDrawer.open, #hdrSearchDrawer.open, #SiteHeaderInner.hovered, #SiteHeader .hovered, ' +
      'cart-drawer.active, .body-lock-scroll, body.overflow-hidden'
    );
  }

  function setHidden(next) {
    if (next === hidden) return;
    hidden = next;
    root.classList.toggle(HIDDEN, hidden);
  }

  function publishBottom() {
    var b = group.getBoundingClientRect().bottom;
    root.style.setProperty('--wasa-r35-hdr-bottom', Math.max(0, Math.round(b)) + 'px');
  }

  function update() {
    queued = false;
    var y = window.pageYOffset || 0;
    var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    if (y < 0 || y > max) { lastY = Math.min(Math.max(y, 0), max); return; }   /* overscroll bounce */
    var delta = y - lastY;
    if (y <= threshold || somethingOpen()) {
      setHidden(false);
    } else if (delta > 4) {
      setHidden(true);
    } else if (delta < -4) {
      setHidden(false);
    }
    if (Math.abs(delta) > 4 || y <= threshold) lastY = y;
    if (!hidden) publishBottom();
  }

  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(update);
  }

  measureThreshold();
  publishBottom();
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', function () { measureThreshold(); queue(); });
  window.addEventListener('load', function () { measureThreshold(); publishBottom(); });
  /* Lazy images and late sections move the Featured Origin section: re-measure now and then. */
  window.setInterval(measureThreshold, 2000);

  /* Keyboard focus or a pointer reaching the top always brings the header back. */
  group.addEventListener('focusin', function () { setHidden(false); publishBottom(); });
  document.addEventListener('mousemove', function (e) {
    if (hidden && e.clientY < 12) { setHidden(false); }
  }, { passive: true });

  /* Homepage cards rise into their rows once (wasa-r35.css block 8). Skipped under reduced motion, and nothing is
     hidden unless this runs. */
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!calm && 'IntersectionObserver' in window && document.body.classList.contains('lx-template--index')) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    var rows = document.querySelectorAll('.wasa-featured-collection__grid, .wasa-fjournal__grid');
    Array.prototype.forEach.call(rows, function (row) {
      if (getComputedStyle(row).overflowX !== 'visible') return;   /* the phone swipe row stays as it is */
      Array.prototype.forEach.call(row.children, function (card, i) {
        var r = card.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) return;   /* already on screen: leave it be */
        card.style.setProperty('--wasa-r35-i', String(i % 3));
        card.classList.add('wasa-r35-reveal');
        io.observe(card);
      });
    });
  }

  /* A menu, search or the bag opening while hidden: show the header first. */
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () { if (hidden && somethingOpen()) setHidden(false); publishBottom(); });
    ['#mobNavDrawer', '#hdrSearchDrawer', '#SiteHeaderInner', 'cart-drawer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) mo.observe(el, { attributes: true, attributeFilter: ['class'] });
    });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
}());
